export default __webpack_public_path__ + "static/media/Snapchat.7e965c5d.png";